export default __webpack_public_path__ + "static/media/amanda_negra.72620d78.png";